/* @flow */
import * as React from 'react';

import Group from 'entities/Group';
import UserActionsMenuButton from 'user/components/UserActionsMenuButton';
import mapGraphQLMemberToUserActionsMenuButtonUser from 'user/lib/mapGraphQLMemberToUserActionsMenuButtonUser';

import type { UserProfile } from 'users/components/UsersProfile';
import type { GroupMemberProfile_classes } from 'users/components/UsersProfile/queries/__generated__/GroupMemberProfile';

export type Props = {
  group: GroupMemberProfile_classes,
  member: UserProfile,
  onUserRemoved: () => void,
  onUserUpdate: () => void,
};

export default function GroupMemberActionsMenuButton(props: Props) {
  const { group, member, onUserRemoved, onUserUpdate } = props;
  const { userInteractionPermissions } = member;
  const {
    canAddAsGroupOwner,
    canBlock,
    canCopyToAnotherGroup,
    canRemoveFromGroup,
    canReportToRemind,
  } = userInteractionPermissions;

  return (
    <UserActionsMenuButton
      buttonSize="xsmall"
      copyToClassText="Add to another class"
      glyphSize="inherit"
      groupToAdmin={((Group.fromJSON(group): any): Group)}
      isAdminView
      showCopyToClass={canCopyToAnotherGroup}
      showBlockMember={canBlock}
      showMakeOwner={canAddAsGroupOwner}
      showRemoveMember={canRemoveFromGroup}
      showReportAsUser={canReportToRemind}
      user={mapGraphQLMemberToUserActionsMenuButtonUser(member)}
      onUserRemoved={onUserRemoved}
      onUserUpdate={onUserUpdate}
      tooltip="More actions"
      tooltipPlacement="top"
    />
  );
}
